import { render, staticRenderFns } from "./EmailsManager.vue?vue&type=template&id=6577bbba"
import script from "./EmailsManager.vue?vue&type=script&lang=js"
export * from "./EmailsManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports